import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
/**
 * @export
 *
 * Used to show data in a matrix or grid. You can give it a list of items and a function to render those items.
 * Items get layed out in a grid and displayed.
 *
 * @example
 * ```
 *  let GridData = [
 *      {
 *          icon: "https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg",
 *          title: "Item Card",
 *          subTitle: "Item card with image/icon Item card with image/icon"
 *      },
 *      {
 *          icon: "",
 *          name: "Dinesh Gamage",
 *          title: "Item Card",
 *          subTitle: "Item card with name"
 *      },
 *      {
 *          icon: "https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg",
 *          title: "Item Card Title & Icon",
 *          subTitle: ""
 *      },
 *      {
 *          icon: "https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg",
 *          title: "",
 *          subTitle: "Item Card sub Title & Icon"
 *      },
 *      {
 *          title: "Item Card",
 *          subTitle: "Item card without image/icon"
 *      },
 *      {
 *          title: "Item Card Title only",
 *      },
 *      {
 *          subTitle: "Item card sub title only"
 *      },
 *      {
 *          icon: "https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg",
 *          title: "QR Code",
 *          subTitle: "scan your code"
 *      },
 *      {
 *          icon: "https://static.iviva.com/images/Adani_UXP/QR_badge_icon.svg",
 *      },
 *      null
 *  ]
 *
 *
 *  function renderGridItem(item: any, key: number){
 *      return (<ItemCard
 *          item={item}
 *          imageField="icon"
 *          titleField="title"
 *          subTitleField="subTitle"
 *          nameField="name"
 *      />)
 *  }
 *
 *  <DataGrid
 *      data={GridData}
 *      renderItem={renderGridItem}
 *      columns={2}
 *  />
 * ```
 *
 */
const DataGrid = (props) => {
    // props
    let { data, renderItem, columns, className } = props;
    // get column width
    let colWidth = Math.round(100 / columns) + "%";
    let colStyles = { width: colWidth };
    // return
    return (_jsx("div", { className: classNames("uxpcore_datagrid data-grid", className || ''), children: data.map((item, key) => {
            return (_jsx("div", { className: "uxpcore_datagrid__column data-grid-column", style: colStyles, children: renderItem(item, key) }, key));
        }) }));
};
export default DataGrid;
